import { render, staticRenderFns } from "./BiddingView.vue?vue&type=template&id=76ab1951&"
import script from "./BiddingView.vue?vue&type=script&lang=js&"
export * from "./BiddingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports